import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDL5yZb9JoHlJc9SYttHiNOnnCYbxerHYY",
    authDomain: "a-dark-place.firebaseapp.com",
    projectId: "a-dark-place",
    storageBucket: "a-dark-place.appspot.com",
    messagingSenderId: "674123373210",
    appId: "1:674123373210:web:68c87d8077de9649755d23"
};

initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore();

export {
    auth,
    db
};
